module.exports = __webpack_public_path__ + "static/media/2-AskFirst.18dbed0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/2-AskFirst.jpg
// module id = 138
// module chunks = 0